import { render, staticRenderFns } from "./claimsInfo2.vue?vue&type=template&id=65ed6f37&scoped=true"
import script from "./claimsInfo2.vue?vue&type=script&lang=js"
export * from "./claimsInfo2.vue?vue&type=script&lang=js"
import style0 from "./claimsInfo2.vue?vue&type=style&index=0&id=65ed6f37&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed6f37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ed6f37')) {
      api.createRecord('65ed6f37', component.options)
    } else {
      api.reload('65ed6f37', component.options)
    }
    module.hot.accept("./claimsInfo2.vue?vue&type=template&id=65ed6f37&scoped=true", function () {
      api.rerender('65ed6f37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/recordFrom/claimsInfo2.vue"
export default component.exports